import React from 'react';
import { Star, Heart, MessageCircle, Play, Mic, Gift } from 'lucide-react';
export const StarsSection = () => {
  return <section className="space-y-6" data-id="element-20582">
      <div className="flex items-center justify-between" data-id="element-20583">
        <div className="flex items-center gap-2" data-id="element-20584">
          <Star size={18} className="text-yellow-400" data-id="element-20585" />
          <h2 className="text-lg font-bold" data-id="element-20586">Stars</h2>
        </div>
        <button className="text-sm text-pink-400" data-id="element-20587">Discover More</button>
      </div>
      <div className="relative" data-id="element-20588">
        <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-gray-950 to-transparent z-10" data-id="element-20589"></div>
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-20590">
          {['All', 'Popular', 'New', 'Online', 'VIP', 'Redheads', 'Blonde', 'Brunette', 'Asian', 'Latina', 'Dominant', 'Submissive'].map((category, i) => <button key={i} className={`px-3 py-1.5 rounded-full text-sm whitespace-nowrap ${i === 0 ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} data-id="element-20591">
              {category}
            </button>)}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-20592">
        {[{
        name: 'Bonny Blue',
        desc: 'Dominant & playful',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
        online: true,
        vip: false,
        hearts: 1240,
        isStar: false
      }, {
        name: 'Kim Holland',
        desc: 'Girl-next-door vibe',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
        online: false,
        vip: false,
        hearts: 980,
        isStar: true
      }, {
        name: 'Mia Khalifa',
        desc: 'Sensual & mysterious',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg',
        online: true,
        vip: false,
        hearts: 1540,
        isStar: true
      }, {
        name: 'Emma Rose',
        desc: 'Sweet & artistic',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wd5J5ve8saMKYCJCDuBt1X/h1.png',
        online: false,
        vip: false,
        hearts: 890,
        isStar: false
      }, {
        name: 'Zoey',
        desc: 'Sweet & seductive',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fnQWPJWMus62iBnJCYdU4W/z1.png',
        online: true,
        vip: false,
        hearts: 1850,
        isStar: false
      }, {
        name: 'Bella Blue',
        desc: 'Fitness enthusiast',
        img: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Qzoa8joo8CQwNu9hB7M4f/b3.png',
        online: true,
        vip: true,
        hearts: 1820,
        isStar: false
      }].map((star, index) => <div key={index} className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden" data-id="element-20593">
            <div className="relative" data-id="element-20594">
              <img src={star.img} alt={star.name} className="w-full aspect-square object-cover" data-id="element-20595" />
              <div className="absolute top-2 right-2 flex gap-1" data-id="element-20596">
                {star.isStar && <div className="px-2 py-0.5 bg-yellow-500/30 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-20597">
                    <Star size={12} className="text-yellow-400" fill="currentColor" data-id="element-20598" />
                    <span className="text-xs text-yellow-300" data-id="element-20599">Star</span>
                  </div>}
                {star.vip && <div className="px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-20600">
                    <Star size={12} className="text-yellow-400" data-id="element-20601" />
                    <span className="text-xs" data-id="element-20602">VIP</span>
                  </div>}
                <div className={`px-2 py-0.5 ${star.online ? 'bg-green-500/20 text-green-400' : 'bg-gray-700/50 text-gray-300'} backdrop-blur-sm rounded-full text-xs`} data-id="element-20603">
                  {star.online ? 'Online' : 'Offline'}
                </div>
              </div>
              <div className="absolute bottom-2 left-2 flex items-center gap-1 px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full" data-id="element-20604">
                <Heart size={12} className="text-pink-400" data-id="element-20605" />
                <span className="text-xs" data-id="element-20606">{star.hearts.toLocaleString()}</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-20607"></div>
            </div>
            <div className="p-3" data-id="element-20608">
              <h3 className="font-medium" data-id="element-20609">{star.name}</h3>
              <p className="text-xs text-gray-400" data-id="element-20610">{star.desc}</p>
              <div className="grid grid-cols-2 gap-2 mt-3" data-id="element-20611">
                <button className="flex items-center justify-center gap-1 py-1.5 bg-pink-600 rounded-lg text-white text-xs" data-id="element-20612">
                  <MessageCircle size={12} data-id="element-20613" />
                  <span data-id="element-20614">Chat</span>
                </button>
                <button className="flex items-center justify-center gap-1 py-1.5 bg-gray-800 rounded-lg text-white text-xs" data-id="element-20615">
                  <Gift size={12} data-id="element-20616" />
                  <span data-id="element-20617">Gift</span>
                </button>
              </div>
            </div>
          </div>)}
      </div>
      <div className="bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-xl border border-pink-800/50 p-4" data-id="element-20618">
        <div className="flex items-center justify-between" data-id="element-20619">
          <div className="flex items-center gap-3" data-id="element-20620">
            <div className="w-10 h-10 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-20621">
              <Star size={18} className="text-yellow-400" data-id="element-20622" />
            </div>
            <div data-id="element-20623">
              <h3 className="font-medium" data-id="element-20624">VIP Access</h3>
              <p className="text-sm text-gray-300" data-id="element-20625">Unlock all premium stars</p>
            </div>
          </div>
          <button className="px-3 py-1.5 bg-gradient-to-r from-yellow-600 to-yellow-500 rounded-lg text-white text-sm" data-id="element-20626">
            Go VIP
          </button>
        </div>
      </div>
      {/* Add Star Membership Banner */}
      <div className="bg-gradient-to-r from-yellow-900/30 to-purple-900/30 rounded-xl border border-yellow-800/50 p-4 mt-6" data-id="element-20627">
        <div className="flex items-center justify-between" data-id="element-20628">
          <div className="flex items-center gap-3" data-id="element-20629">
            <div className="w-14 h-14 flex items-center justify-center bg-yellow-500/20 rounded-full text-yellow-400" data-id="element-20630">
              <Star size={24} className="text-yellow-400" fill="currentColor" data-id="element-20631" />
            </div>
            <div data-id="element-20632">
              <h3 className="font-medium text-lg" data-id="element-20633">Stars Membership</h3>
              <p className="text-sm text-gray-300" data-id="element-20634">
                Unlock all premium stars content
              </p>
              <div className="flex mt-1 items-center gap-1" data-id="element-20635">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png" alt="Kim Holland" className="w-5 h-5 rounded-full object-cover border border-yellow-500" data-id="element-20636" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg" alt="Mia Khalifa" className="w-5 h-5 rounded-full object-cover border border-yellow-500" data-id="element-20637" />
                <span className="text-xs text-gray-400" data-id="element-20638">+5 more stars</span>
              </div>
            </div>
          </div>
          <button className="px-4 py-2 bg-gradient-to-r from-yellow-600 to-yellow-500 rounded-lg text-white text-sm font-medium" data-id="element-20639">
            $14.99/mo
          </button>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-3" data-id="element-20640">
          <div className="bg-gray-800/50 rounded-lg p-2 text-center" data-id="element-20641">
            <span className="text-xs text-gray-300" data-id="element-20642">Unlimited access</span>
          </div>
          <div className="bg-gray-800/50 rounded-lg p-2 text-center" data-id="element-20643">
            <span className="text-xs text-gray-300" data-id="element-20644">Exclusive content</span>
          </div>
          <div className="bg-gray-800/50 rounded-lg p-2 text-center" data-id="element-20645">
            <span className="text-xs text-gray-300" data-id="element-20646">Private shows</span>
          </div>
        </div>
      </div>
      {/* Personalized Merchandise */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl border border-gray-700 overflow-hidden mt-6" data-id="element-20647">
        <div className="p-3 border-b border-gray-800" data-id="element-20648">
          <h3 className="font-medium" data-id="element-20649">Star Merchandise</h3>
        </div>
        <div className="grid grid-cols-2 gap-0.5" data-id="element-20650">
          <div className="relative group p-3 bg-gray-800/50" data-id="element-20651">
            <div className="aspect-square rounded-lg overflow-hidden mb-2" data-id="element-20652">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png" alt="Kim Holland Merch" className="w-full h-full object-cover" data-id="element-20653" />
            </div>
            <h4 className="text-sm font-medium" data-id="element-20654">Kim's Special Toy</h4>
            <div className="flex justify-between items-center mt-1" data-id="element-20655">
              <span className="text-xs text-yellow-400" data-id="element-20656">Limited Edition</span>
              <span className="text-xs font-bold" data-id="element-20657">$49.99</span>
            </div>
          </div>
          <div className="relative group p-3 bg-gray-800/50" data-id="element-20658">
            <div className="aspect-square rounded-lg overflow-hidden mb-2" data-id="element-20659">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg" alt="Mia Khalifa Merch" className="w-full h-full object-cover" data-id="element-20660" />
            </div>
            <h4 className="text-sm font-medium" data-id="element-20661">Mia's Signature Toy</h4>
            <div className="flex justify-between items-center mt-1" data-id="element-20662">
              <span className="text-xs text-yellow-400" data-id="element-20663">Bestseller</span>
              <span className="text-xs font-bold" data-id="element-20664">$59.99</span>
            </div>
          </div>
        </div>
        <div className="p-3 flex items-center justify-between" data-id="element-20665">
          <div className="text-xs text-gray-400" data-id="element-20666">
            Exclusive star merchandise
          </div>
          <button className="text-xs px-3 py-1 bg-gradient-to-r from-yellow-600 to-yellow-500 rounded-full text-white" data-id="element-20667">
            View Shop
          </button>
        </div>
      </div>
    </section>;
};